import { useEffect, useState } from 'react';
import { ANG_APIS } from '../../api.constants';
import { useParams } from 'react-router-dom';
import Pole from './Others/Pole';
import Wall from './Others/Wall';
import CommunityHall from './Others/CommunityHall';
import SwimmingPool from './Others/SwimmingPool';
import StreetFurniture from './Others/StreetFurniture';
import SportsFacilities from './Others/SportsFacilities';
import APIService from '../../../Services/APIService';

export default function SocietyAdditionalDetails() {
  const [other, setOther] = useState();
  const [pole, setPole] = useState([]);
  const [showPole, setShowPole] = useState(false);
  const [showWall, setShowWall] = useState(false);
  const [showCommunityHall, setShowCommunityHall] = useState(false);
  const [showSwimmingPool, setShowSwimmingPool] = useState(false);
  const [showStreetFurniture, setShowStreetFurniture] = useState(false);
  const [showSportsFacilities, setShowSportsFacilities] = useState(false);
  const [wall, setWall] = useState([]);
  const [communityHall, setCommunityHall] = useState([]);
  const [swimmingPool, setSwimmingPool] = useState([]);
  const [streetFurniture, setStreetFurniture] = useState([]);
  const [sportsFacilities, setSportsFacilities] = useState([]);
  const { id } = useParams();

  const getAdditional = async () => {
    let res = await APIService.get(ANG_APIS.GET_OTHER);
    if (res) setOther(res.data)
  };

  useEffect(() => {
    getAdditional();
  }, []);

  const handleShowPole = () => {
    setShowPole(!showPole);
  };
  const handleShowWall = () => {
    setShowWall(!showWall);
  };
  const handleShowCommunityHall = () => {
    setShowCommunityHall(!showCommunityHall);
  };
  const handleShowSwimmingPool = () => {
    setShowSwimmingPool(!showSwimmingPool);
  };
  const handleShowStreetFurniture = () => {
    setShowStreetFurniture(!showStreetFurniture);
  };
  const handleShowSportsFacilities = () => {
    setShowSportsFacilities(!showSportsFacilities);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div style={{ marginTop: '30px' }}></div>
      <div ng-controller="AdditionalInventoryDetailCtrl">
        <form
          name="myForm"
          sf-schema="schema"
          sf-form="form"
          sf-model="model"
          role="form"
          ng-submit="onSubmit(myForm)"
          onSubmit={handleSubmit}
        >
          <div className="schema-form-section">
            <div className="checkbox schema-form-checkbox col-xs-12 has-success">
              <label className="">
                <input
                  type="checkbox"
                  className="ng-valid-schema-form ng-dirty ng-valid-parse ng-touched"
                  name="pole_available"
                />
                <span onClick={handleShowPole} className="ng-binding">
                  Pole Available
                </span>
              </label>
            </div>
            {showPole && <Pole formData={pole} setFormData={setPole} />}
            <div className="checkbox schema-form-checkbox col-xs-12 has-success">
              <label className="">
                <input
                  type="checkbox"
                  className="ng-valid-schema-form ng-dirty ng-valid-parse ng-touched"
                  name="pole_available"
                />
                <span onClick={handleShowWall} className="ng-binding">
                  Wall Available
                </span>
              </label>
            </div>
            {showWall && <Wall formData={wall} setFormData={setWall} />}
            <div className="checkbox schema-form-checkbox col-xs-12 has-success">
              <label className="">
                <input
                  type="checkbox"
                  className="ng-valid-schema-form ng-dirty ng-valid-parse ng-touched"
                  name="pole_available"
                />
                <span onClick={handleShowCommunityHall} className="ng-binding">
                  Community Hall Available
                </span>
              </label>
            </div>
            {showCommunityHall && (
              <CommunityHall formData={communityHall} setFormData={setCommunityHall} />
            )}
            <div className="checkbox schema-form-checkbox col-xs-12 has-success">
              <label className="">
                <input
                  type="checkbox"
                  className="ng-valid-schema-form ng-dirty ng-valid-parse ng-touched"
                  name="pole_available"
                />
                <span onClick={handleShowSwimmingPool} className="ng-binding">
                  Swimming Pool Available
                </span>
              </label>
            </div>
            {showSwimmingPool && (
              <SwimmingPool formData={swimmingPool} setFormData={setSwimmingPool} />
            )}
            <div className="checkbox schema-form-checkbox col-xs-12 has-success">
              <label className="">
                <input
                  type="checkbox"
                  className="ng-valid-schema-form ng-dirty ng-valid-parse ng-touched"
                  name="pole_available"
                />
                <span onClick={handleShowStreetFurniture} className="ng-binding">
                  Street Furniture Available
                </span>
              </label>
            </div>
            {showStreetFurniture && (
              <StreetFurniture formData={streetFurniture} setFormData={setStreetFurniture} />
            )}
            <div className="checkbox schema-form-checkbox col-xs-12 has-success">
              <label className="">
                <input
                  type="checkbox"
                  className="ng-valid-schema-form ng-dirty ng-valid-parse ng-touched"
                  name="pole_available"
                />
                <span onClick={handleShowSportsFacilities} className="ng-binding">
                  Sports Facilities Available
                </span>
              </label>
            </div>
            {showSportsFacilities && (
              <SportsFacilities formData={sportsFacilities} setFormData={setSportsFacilities} />
            )}

            <div className="form-group schema-form-submit col-xs-4">
              <input type="submit" className="btn btn-primary " value="Add Others Details" />
            </div>
          </div>
        </form>
      </div>
    </>
  );
}
